import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/pro-light-svg-icons';

import styles from './index.module.sass';

const Search = () => (
    <div className={styles.searchSection}>
      <form className={styles.searchForm} action="/search" method="get">
        <input
          aria-label="Search"
          type="text"
          name="q"
          id="q"
          placeholder="Search for crabs, crab cakes, seafood..."
          className={styles.searchInput}
          autoComplete="off"
        />
        <button type="submit" className={styles.searchButton}>
          <FontAwesomeIcon className={styles.searchIcon} icon={faMagnifyingGlass} />
        </button>
      </form>
    </div>
  );

export default Search;
